
import { pp, pp_user, app_state, notify, myConfirmDialog } from '@helpers'

// import { courseStore } from "@stores";

export const useColisStore = {

    state: ()/* : State */ => ({

        form: {},

        formAddRecipient: {}, // créer un Destinataire quand on ajoute un colis
        showRecipientAddForm: false,

        // options_status: [
        //     {label: 'En attente',           value: 0},
        //     {label: 'Pris en Charge',       value: 1},
        //     {label: 'Livré',                value: 2},
        //     {label: 'Personne au RDV',      value: 3},
        //     {label: 'Colis Refusé',         value: 4}
        // ],

        // options_natures: ['Colis','Palettes','Cintres'/* ,'Autres' NON */], // passé par PHP

        // options_livraisons: [
        //     {label:'Normale', value: 1},
        //     {label:'Expresse', value: 2}
        // ],

        options_types: ['Fragile','Lourd','Gros','Petit','RAS'],

        filter: '',

        // for create Carrier Doc
        // show_checkbox_selectors: false,
        // selected: {},
        // select_all: false,

        openModalPhotos: false,
        itemForPhotos: null,

        colis_ref_list_for_copy_to_clipboard__by_course: {},
    }),

    getters: {

        getStatusLabel(){

            // return (status) => {
                // // return _.find(pp().options_status_colis, {value: Number(status)})/* ?.label */ ?? ''
                // return pp().options_status_colis[status] ?? ' - '
            // }

            return (status, plural = false) => {
                var s = {}
                if(_.isString(status)){
                    s = _.find(pp().options_status, {skey: status})
                } else { // id status
                    s = _.find(pp().options_status, {id: status})
                }

                return s ?  s['value'+(plural ? '_plural' : '')] : '?'
            }

        },
        getStatusPos(){

            return (status_skey) => _.find(pp().options_status, {skey: status_skey})?.pos ?? 0
        },
        getStatusColor(){
            // return (status) => {
            //     var color = 'warning'
            //     if(status === 0){ color = 'grey' }
            //     if(status === 1){ color = 'teal-5' }
            //     if(status === 2){ color = 'positive' }
            //     return color
            // }
            return (status) => {
                var s = null
                if(_.isString(status)){
                    s = _.find(pp().options_status, {skey: status})
                } else { // id status
                    s = _.find(pp().options_status, {id: status})
                }

                return s ?  s.color : 'grey'
            }
        },
        getStatusIcon(){
            // return (status) => {
            //     var icon = 'hourglass_top'
            //     if(status === 1){ icon = 'local_shipping' }//'precision_manufacturing'
            //     if(status === 2){ icon = 'done_all' }
            //     if(status === 3){ icon = 'person_off' }
            //     if(status === 4){ icon = 'highlight_off' }
            //     return icon
            // }
            return (status) => {
                var s = null
                if(_.isString(status)){
                    s = _.find(pp().options_status, {skey: status})
                } else { // id status
                    s = _.find(pp().options_status, {id: status})
                }

                return s ?  s.icon : ''
            }
        },

        // getLivraisonLabel(){

        //     return (livraison) => {
        //         return _.find(this.options_livraisons, {value: Number(livraison)})?.label ?? ' - '
        //     }
        // },

        // getLivraisonColor(){

        //     return (livraison) => {
        //         return (livraison == 2 ? 'red-9' : 'info')
        //     }
        // },


        getShopLabel(){ // Expéditeur

            return (item) => {
                // let shop = _.isArray(item?.client?.shop) ? _.head(item?.client?.shop) : item.client.shop
                let shop = item?.shop
                let label = (shop?.label ?? ' - ') +' ('+ (shop?.business?.label ?? shop?.business_label ?? ' - ') +')'

                return label
            }
        },
        getRecipientLabel(){ // Destinataire

            return (item) => {
                // return item?.recipient?.label ?? ' - '
                let recipient = item?.recipient

                let label = (recipient?.label ?? ' - ') +' ('+ (recipient?.business?.label ?? ' - ') +')'

                return label
            }
        },


        waiting(){ // En Attente
            // return (status)=> status === 0
            return (status)=> status.skey == 'waiting'
        },
        accepted(){ // Accepté par le transporteur
            // return (status)=> status === 0
            return (status)=> status.pos >= this.getStatusPos('accepted')
        },
        refused(){ // refusé par le transporteur
            return (status)=> status.skey == 'refused'
        },
        supported(){ // pris en charge
            // return (status)=>status >= 1
            return (status)=> status.pos >= this.getStatusPos(status.skey)// 'supported'
        },
        delivered(){ // livré
            // return (status)=> status === 2
            return (status)=> status.skey == 'delivered'
        },
        nobody(){ // personne au rdv
            // return (status)=> status === 3
            return (status)=> status.skey == 'nobody'
        },
        denied(){ // refusé par le destinataire
            // return (status)=> status === 4
            return (status)=> status.skey == 'denied'
        },
        notDelivered(){ // colis pris en charge  ET  non livré
            // return (status)=> (this.supported(status) || status > 2)
            return (status)=> status.skey != 'delivered'
        },
        // waitingOrnotDelivered(){ // colis en attente de prise en charge  OU  non livré
        //     return (status)=> (this.waiting(status) || status > 2)
        // },


    },

    actions: {

        setColis(colis){
            if( ! colis){ colis = {} } // for Create


            // var dim = colis.dimensions?.split('x')

            colis = {
                ...colis,

                // pour colis & courses tables
                course_id:      colis.course_id ?? null,
                driver_id:      colis.driver_id ?? null,

                id:             colis.id                ?? null,
                // label:          colis.label             ?? '',
                // recipient_id:   colis.recipient_id      ?? null,            // destinataire  / plus besoin, déjà dans la Course...
                user_id:        colis.user_id           ?? pp_user()?.id,   // id client
                status:         colis.status            ?? 0,               // 0: En attente | 1: En cours de livraison | 2: Livré | 3: Personne au RDV | 4: Colis refusé
                nature:         colis.nature            ?? 'Colis',         // Colis|Palettes|Cintres|Autres
                qty:            colis.qty               ?? 1,               // Quantité de marchandises
                value:          colis.value             ?? null,            // Valeur estimée
                // livraison:      colis.livraison         ?? 1,               // 1: normale 2: expresse
                type:           colis.type              ?? null,
                // dimensions:     colis.dimensions        ?? null,
                // L:              dim?.[0]                ?? 0,
                // l:              dim?.[1]                ?? 0,
                // H:              dim?.[2]                ?? 0,
                poids:          colis.poids             ?? null,
                ref:            colis.ref               ?? null,            // référence Unique du colis
                // carrier_doc:    colis.carrier_doc       ?? null,            // Lettre de Voiture - Doc du transporteur
                // remarks:        colis.remarks           ?? null,
                // date_start:     colis.date_start        ?? null,            // date de demande
                // date_status2:    colis.date_status2       ?? null,            // date de prise en charge
                // date_status2:       colis.date_status2          ?? null,            // date livraison
            }

            return colis
        },

        // for Edit (in Index) and Create
        initForm(colis){

            colis = this.setColis(colis)

            this.form = proto.$inertia.form(colis)

            // log('in stores/colis @initForm()',this.form)
        },


        // for Edit (in Index) and Create
        submit(status = null){

            var router = this.form.id ? route('colis.update', this.form.id) : route('colis.store')

            const formDatas = this.form.data()

            // var L = Number(formDatas.L)
            // var l = Number(formDatas.l)
            // var H = Number(formDatas.H)

            // if(pp().isDriver){

            //     if( ! _.isNull(status)){
            //         this.form.status = status
            //     }
            // }
            // else {

            //     // if((!L || !l || !H)){ return notify('warning',"Veuillez indiquer des dimensions correctes") }
            //         // delete formDatas.L ben non.. ça vide le form.. :/
            //         // delete formDatas.l
            //         // delete formDatas.H
            // }

            this.form
                .transform(data => ({
                    ...data,
                    // dimensions: `${L}x${l}x${H}`,
                }))
                [this.form.id ? 'put' : 'post'](router, {
                    preserveScroll: true,
                    // onSuccess: () => {
                    //     this.form.reset();
                    // },
                });

        },

        updateStatus(colis, status_skey){

            // var statusStr = this.getStatusLabel(status)
            var statusStr = this.getStatusLabel(status_skey)

            // $q.dialog({title: 'Confirmation...', message:`<p>Enregistrer le statut de ce colis<br/>sur « ${statusStr} »</p>`, html: true,
            //     ok:{label: 'Enregistrer',noCaps: true,color: 'positive',outline: true, square: true}, cancel:true, persistent: true})
            // .onOk(()=>{

            //     proto.$inertia.post(route('colis-update-status', colis.id), {status_skey: status_skey}, { preserveScroll: true, })

            // })

            myConfirmDialog(
                ()=> proto.$inertia.post(route('colis-update-status', colis.id), {status_skey: status_skey}, { preserveScroll: true, }),
                `<p>Enregistrer le statut de ce colis<br/>sur « ${statusStr} »</p>`
            )

        },


     /*    // for add Recipient, for an user (client)
        addRecipient(business_id){
            if(business_id){

                this.showRecipientAddForm = true

                this.formAddRecipient = proto.$inertia.form({
                    label: '',
                    business_id: business_id,
                    description: '',
                    contact: '',
                    email: '',
                    phone: '',
                    address: '',
                    latitude: null,
                    longitude: null,
                })
            }
        },

        submitAddRecipient(){

            this.formAddRecipient.post(route('add-recipient'),{
                preserveScroll: true,
                onSuccess:(res)=>{

                    this.showRecipientAddForm = false

                    this.form.recipient_id = res.props.result

                    this.formAddRecipient.reset()
                }
            })
        },


        createCarrierDoc(colis_id){

            var colis_ids = colis_id ? [colis_id] : []

            _.filter(this.selected, (v, id) => {
                if(v){ colis_ids.push(Number(id)) }
            })

            var count_colis = _.size(colis_ids)

            if(count_colis){

                var drivers = _.filter(app_state().all_users, u=> _.includes(u.roles, 5))

        // log('in createCarrierDoc()',count_colis,colis_id, colis_ids, this.selected, drivers)

                $q.dialog({ title: 'Pour quel chauffeur ?', //  message: 'Choose an option:',
                    options: { type: 'radio',  model: null, items: drivers},
                    ok:{label: 'Continuer'}, cancel: true, persistent: true
                }).onOk(driver_id => {

                    if(! driver_id){
                        notify('warning',"Veuillez choisir un chauffeur")
                        return this.createCarrierDoc()
                    }

                    var driver_name = _.find(app_state().all_users, {value: driver_id})?.label

                    $q.dialog({title: "Confirmation...",message:`<p>Créer la lettre de voiture pour les ${count_colis} colis sélectionnés</p><p>Chauffeur: ${driver_name}</p>`,
                        html:true, cancel:true, ok:{label:'Créer',color:'positive'},
                        persistent: true,
                        prompt: {
                            label: 'Instructions particulières (facultatif)',
                            model: '',
                            type: 'textarea', rows: 6, // optional
                        },
                    }).onOk((txt)=>{
                        $q.loading.show({message: "Création en cours..."})

                        proto.$inertia.post(route(`course.store`), { ids: colis_ids, driver_id: driver_id, txt: txt },{
                                preserveScroll: true,
                                onSuccess:()=>{$q.loading.hide()},
                                onError:()=>{$q.loading.hide()}
                            })
                    })
                })

            } else {
                notify('warning', "Aucun colis sélectionné...")
            }

        },
 */

    }
}
